import { ApolloError, WatchQueryFetchPolicy } from "@apollo/client";

import { useFetchCurrentAccountQuery } from "src/entities/account/document.gen";

type FetchCurrentAccountQueryResult = NonNullable<
  NonNullable<NonNullable<ReturnType<typeof useFetchCurrentAccountQuery>>["data"]>["currentAccount"]
>;

type Props = {
  onCompleted?: (account: FetchCurrentAccountQueryResult) => void;
  skip?: boolean;
  fetchPolicy?: WatchQueryFetchPolicy;
};

const AUTH_BASE_URL = process.env.NEXT_PUBLIC_AUTH_URL;
const CLIENT_ID = "momo";

export const useCurrentAccount = (props?: Props) => {
  const { data, loading, refetch, error } = useFetchCurrentAccountQuery(
    !props?.skip
      ? {
          fetchPolicy: props?.fetchPolicy,
          onCompleted: (data) => {
            !!props?.onCompleted && !!data.currentAccount && props.onCompleted(data.currentAccount);
          },
        }
      : { skip: true },
  );

  return {
    currentAccount: data?.currentAccount,
    loading,
    refetch,
    error,
  };
};

export const currentClinicError = (error: ApolloError) => {
  for (const graphQLError of error.graphQLErrors) {
    const path = graphQLError.path;

    if (path && path[0] === "currentAccount" && path[1] === "currentClinic") {
      return true;
    }
  }

  return false;
};

export const getSigninUrl = (redirect_uri: string) => {
  return (
    `${AUTH_BASE_URL}` +
    "?" +
    new URLSearchParams({
      client_id: CLIENT_ID,
      redirect_uri: redirect_uri,
    }).toString()
  );
};
